// Must run before AppModule so side-effect library plugins (e.g. leaflet.markercluster)
// are attached deterministically before any component/directive uses them under esbuild.
import './plugin-init';

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
